var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('signature-pad',{ref:"spad"}),_c('button',{on:{"click":_vm.getSpad}},[_vm._v("get")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }